/* UHF Pinterest save buttons, v1 (2026-10-29).
   A small "Save" pill appears on hover over (a) product-card images and (b) the main product-page
   image under the cursor. Thumbnails, the zoom lightbox, quick-add modals and touch-only devices get
   no button. Pins use the exact product image shown (Shopify CDN, width=1200) and the canonical
   /products/<handle> URL with UTMs.
   To remove: delete this asset and its <script> line at the end of snippets/meta-tags.liquid. */
(function () {
  if (window.__uhfPin) return;
  window.__uhfPin = 1;

  var s = document.currentScript;
  var SHOP = ((s && s.dataset.shopUrl) || location.origin).replace(/\/$/, '');
  var NAME = (s && s.dataset.shopName) || 'Urban House Fashion';
  var UTM = 'utm_source=pinterest&utm_medium=social&utm_campaign=site_save_button';
  var ICON =
    '<svg viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path fill="currentColor" d="M10 2.01a8.1 8.1 0 0 1 5.666 2.353 8.09 8.09 0 0 1 1.277 9.68A7.95 7.95 0 0 1 10 18.04a8.2 8.2 0 0 1-2.276-.307c.403-.653.672-1.24.816-1.729l.567-2.2c.134.27.393.5.768.702.384.192.768.297 1.19.297q1.254 0 2.248-.72a4.7 4.7 0 0 0 1.537-1.969c.37-.89.554-1.848.537-2.813 0-1.249-.48-2.315-1.43-3.227a5.06 5.06 0 0 0-3.65-1.374c-.893 0-1.729.154-2.478.461a5.02 5.02 0 0 0-3.236 4.552c0 .72.134 1.355.413 1.902.269.538.672.922 1.22 1.152.096.039.182.039.25 0 .066-.028.114-.096.143-.192l.173-.653c.048-.144.02-.288-.105-.432a2.26 2.26 0 0 1-.548-1.565 3.803 3.803 0 0 1 3.976-3.861c1.047 0 1.863.288 2.44.855.585.576.883 1.315.883 2.228a6.8 6.8 0 0 1-.317 2.122 3.8 3.8 0 0 1-.893 1.556c-.384.384-.836.576-1.345.576-.413 0-.749-.144-1.018-.451-.259-.307-.345-.672-.25-1.085q.22-.77.452-1.537l.173-.701c.057-.25.086-.451.086-.624 0-.346-.096-.634-.269-.855-.192-.22-.451-.336-.797-.336-.432 0-.797.192-1.085.595-.288.394-.442.893-.442 1.499.005.374.063.746.173 1.104l.058.144c-.576 2.478-.913 3.938-1.037 4.36-.116.528-.154 1.153-.125 1.863A8.07 8.07 0 0 1 2 10.03c0-2.208.778-4.11 2.343-5.666A7.72 7.72 0 0 1 10 2.001z"/></svg>';

  var css =
    /* !important on box props: Dawn sets .product__media-item > * {display:block;position:relative} */
    '.uhf-pin{position:absolute!important;top:1rem!important;right:1rem!important;left:auto!important;bottom:auto!important;width:auto!important;margin:0!important;z-index:5;display:inline-flex!important;align-items:center;gap:.4rem;height:2.8rem;padding:0 1rem 0 .7rem;border-radius:1.4rem;background:#E60023;color:#fff!important;font:700 1.2rem/1 -apple-system,BlinkMacSystemFont,"Segoe UI",Helvetica,Arial,sans-serif;letter-spacing:0;text-decoration:none!important;box-shadow:0 1px 4px rgba(0,0,0,.18);opacity:0;pointer-events:none;transition:opacity .15s ease}' +
    '.uhf-pin svg{width:1.5rem;height:1.5rem;flex:none}' +
    '.uhf-pin:hover{background:#AD081B}' +
    '.uhf-pin:focus-visible{opacity:1;pointer-events:auto;outline:2px solid #fff;outline-offset:2px}' +
    'media-gallery .product__media-item{position:relative}' +
    '@media (hover:hover){.product-card-wrapper:hover .uhf-pin,media-gallery .product__media-item:hover .uhf-pin{opacity:1;pointer-events:auto}}' +
    '@media (prefers-reduced-motion:reduce){.uhf-pin{transition:none}}';
  var st = document.createElement('style');
  st.textContent = css;
  document.head.appendChild(st);

  function productPath(href) {
    var m = (href || '').match(/\/products\/[^/?#]+/);
    return m ? m[0] : null;
  }

  function imgUrl(img) {
    var src = img && (img.currentSrc || img.src);
    if (!src) return null;
    try {
      var u = new URL(src, location.href);
      u.protocol = 'https:';
      u.searchParams.set('width', '1200');
      u.searchParams.delete('height');
      u.searchParams.delete('crop');
      return u.toString();
    } catch (e) {
      return null;
    }
  }

  function makeBtn(placement) {
    var a = document.createElement('a');
    a.className = 'uhf-pin';
    a.href = 'https://www.pinterest.com/pin/create/button/';
    a.target = '_blank';
    a.rel = 'noopener nofollow';
    a.setAttribute('aria-label', 'Save to Pinterest');
    a.dataset.uhfPin = placement;
    a.innerHTML = ICON + '<span aria-hidden="true">Save</span>';
    return a;
  }

  function galleryItem(t) {
    var li = t.closest('media-gallery .product__media-item');
    if (!li || li.closest('.quick-add-modal')) return null;
    if (!li.querySelector('img') || li.querySelector('deferred-media,product-model,video,iframe')) return null;
    return li;
  }

  // Buttons are created lazily on first hover (or keyboard focus), so dynamically loaded cards
  // (related products, infinite scroll) are covered without observers.
  function ensure(e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var card = t.closest('.product-card-wrapper');
    if (card) {
      // Host on .card-wrapper, not .card__inner: Dawn gives .card__inner a transform, which creates a
      // stacking context that traps the button under the card's full-card link overlay.
      if (card.querySelector('.card__media img') && card.querySelector('.card__heading a[href]') && !card.querySelector(':scope > .uhf-pin')) {
        card.appendChild(makeBtn('card'));
      }
      return;
    }
    var li = galleryItem(t);
    if (li && !li.querySelector(':scope > .uhf-pin')) li.appendChild(makeBtn('pdp'));
  }

  if (window.matchMedia && matchMedia('(hover: hover)').matches) {
    document.addEventListener('pointerover', ensure, { passive: true });
  }
  document.addEventListener('focusin', ensure);

  document.addEventListener(
    'click',
    function (e) {
      var a = e.target.closest && e.target.closest('a.uhf-pin');
      if (!a) return;
      e.preventDefault();
      e.stopPropagation();

      var placement = a.dataset.uhfPin;
      var path, title, img;
      if (placement === 'card') {
        var card = a.closest('.product-card-wrapper');
        var link = card.querySelector('.card__heading a[href]');
        path = productPath(link.href);
        title = link.textContent.trim();
        var imgs = card.querySelectorAll('.card__media img');
        img = imgs[0];
        // Pin whichever image is actually showing (Dawn swaps to the secondary image on hover).
        if (imgs[1] && parseFloat(getComputedStyle(imgs[1]).opacity) > 0.5) img = imgs[1];
      } else {
        var li = a.closest('.product__media-item');
        img = li.querySelector('img');
        path = productPath(location.pathname);
        var h = document.querySelector('.product__title h1, .product__title h2');
        title = h ? h.textContent.trim() : document.title;
      }

      var media = imgUrl(img);
      if (!path || !media) return;
      var url = SHOP + path + '?' + UTM;
      var href =
        'https://www.pinterest.com/pin/create/button/?url=' + encodeURIComponent(url) +
        '&media=' + encodeURIComponent(media) +
        '&description=' + encodeURIComponent(title + ' | ' + NAME);

      try {
        window.Shopify.analytics.publish('uhf_pinterest_save_click', { placement: placement, product_path: path, image: media });
      } catch (_) {}

      var w = window.open(href, 'uhfpin', 'width=750,height=640,scrollbars=yes');
      if (w) {
        try { w.opener = null; } catch (_) {}
      } else {
        window.location.href = href;
      }
    },
    true
  );
})();
